import { GOOGLE_ADS_CAMPAIGN_STATUS } from '../../../../../../../services/exports/Constants';

export default {
  buttons: {
    back: 'Înapoi',
  },
  metrics: {
    impressions: {
      label: 'Afișări',
      description: 'Numărul de afișări ale anunțului tău în rezultatele căutării Google sau pe site-urile partenere.',
    },
    clicks: {
      label: 'Clicuri',
      description: 'Numărul de clicuri ale utilizatorilor pe anunțul tău.',
    },
    budget_spent: {
      label: 'Buget cheltuit',
      description: 'Suma totală de bani cheltuită pe această campanie.',
    },
    absolute_top_impression_percentage: {
      label: '% Afișări Top Absolut',
      description: 'Procentul de ori în care anunțul tău a apărut în fruntea absolută a rezultatelor Google.',
    },
    phone_calls: {
      label: 'Apeluri',
      description: 'Numărul total de apeluri telefonice primite din anunțul tău.',
    },
    phone_impressions: {
      label: 'Afișări telefon',
      description: 'Numărul de ori în care numărul tău de telefon a fost afișat în anunț.',
    },
    phone_through_rate: {
      label: 'Rată apeluri telefon',
      description: 'Procentul afișărilor de telefon care au dus la apeluri reale (Apeluri ÷ Afișări telefon).',
    },
    directions: {
      label: 'Indicații rutiere',
      description: 'Numărul de ori în care utilizatorii au accesat indicații rutiere spre locația afacerii tale.',
    },
    daily_budget: {
      label: 'Buget zilnic',
      description: 'Suma maximă setată pentru cheltuieli zilnice pe această campanie.',
    },
    status: {
      label: 'Stare',
      description: 'Starea curentă de rulare a campaniei tale.',
    },
    ctr: {
      label: 'Rată de clic',
      description: 'Procentul de afișări ale anunțului care au dus la clicuri (Clicuri ÷ Afișări).',
    },
    average_cpc: {
      label: 'Cost mediu pe clic',
      description:
        'Suma medie plătită de fiecare dată când cineva face clic pe anunțul tău (Cost total ÷ Clicuri totale).',
    },
    conversions_from_interactions_rate: {
      label: 'Rată de conversie',
      description: 'Procentul interacțiunilor cu anunțul care au dus la o conversie.',
    },
    start_date: {
      label: 'Dată de început',
      description: 'Data la care a început campania.',
    },
    sales_from_google_ads: {
      label: 'Vânzări din Google Ads',
      description: 'Suma totală de bani generată prin Google Ads.',
    },
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Nespecificat',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Activat',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Pauzat',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Necunoscut',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Eliminat',
  },
  error_messages: {
    loading_failed: 'Încărcarea detaliilor campaniei a eșuat. Vă rugăm să încercați din nou.',
  },
};
